import React, {ReactNode} from "react"

type PageContentProps = {
    children?: ReactNode
    footer?: boolean
    overflow?: boolean
}

const PageContent: React.FC<PageContentProps> = ({footer, children, overflow}) => {
    return (
        <div
            className={`${footer ? "h-[calc(100vh-3.5rem)]" : "h-screen"} ${overflow ? "overflow-y-auto" : "no-scrollbar overflow-hidden"} -m-1 p-4`}
        >
            {children}
        </div>
    )
}

export default PageContent
